import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from "react-router-dom";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";

const Gridorderlist = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const botData = location.state;
  const path = usercalls();
  const [botDetails, setBotDetails] = useState(botData || null);
  const [gridOrders, setGridOrders] = useState([]);
  const [botEnabled, setBotEnabled] = useState(botData?.is_enabled || false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const getGridOrders = async () => {
    if (!botDetails?.id) return;

    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-grid-orders`;
      const payload = { id: botDetails.id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const gridLinesOrders = result.grid_lines_orders || [];
        const balancingOrders = result.balancing_orders || [];
        // Combine both arrays and add a type field
        const allOrders = [
          ...gridLinesOrders.map((order) => ({
            ...order,
            orderCategory: "Grid Line",
          })),
          ...balancingOrders.map((order) => ({
            ...order,
            orderCategory: "Balancing",
          })),
        ];
        setGridOrders(allOrders);
      } else {
      }
    } catch (err) {
    } finally {
      setTradeLoading(false);
    }
  };

  useEffect(() => {
    if (!botData?.id) {
      navigate("/bot");
    }
  }, [botData?.id, navigate]);

  useEffect(() => {
    getGridBotDetails();
  }, [botData?.id]);

  useEffect(() => {
    if (botDetails?.id) {
      getGridOrders();
    }
  }, [botDetails?.id]);

  useEffect(() => {
    if (botData?.is_enabled !== undefined) {
      setBotEnabled(botData.is_enabled);
    }
    if (botData) {
      setBotDetails(botData);
    }
  }, [botData]);

  const getGridBotDetails = async () => {
    if (!botData?.id) return;

    try {
      const url = `${consts.BackendUrl}/bots/get-grid-botlist`;
      const payload = { id: botData.id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const details = Array.isArray(result.result)
          ? result.result[0]
          : result.result || null;
        if (details) {
          setBotDetails(details);
          if (details.is_enabled !== undefined) {
            setBotEnabled(details.is_enabled);
          }
        }
      } else {
      }
    } catch (err) {}
  };

  const handleToggleBotStatus = async (nextEnabled) => {
    if (!botDetails?.id) {
      toast.error("Bot id is missing");
      return;
    }

    const type = nextEnabled ? "enable" : "disable";
    setToggleLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/toggle-grid-bot`;
      const payload = { id: botDetails.id, type };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || `Bot ${type}d successfully`);
        setBotEnabled(nextEnabled);
        await getGridBotDetails();
      } else {
        toast.error(result?.message || `Failed to ${type} bot`);
      }
    } catch (err) {
      toast.error(`Failed to ${type} bot`);
    } finally {
      setToggleLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const activePaginated = gridOrders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const formatDate = (dateString) => {
    if (!dateString) return "---";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container className="mb-20">
        <Grid item xs={12}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6} lg={12}>
          <div className="bot_container contain-width mb-20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Name</h4>
                  <div>{botDetails?.name || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Pair</h4>
                  <div>{botDetails?.pair || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Status</h4>
                  <div>{botEnabled ? "Enabled" : "Disabled"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Grids</h4>
                  <div>{botDetails?.grids_quantity || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Grid Type</h4>
                  <div>
                    {botDetails?.grid_type
                      ? botDetails.grid_type.charAt(0).toUpperCase() +
                        botDetails.grid_type.slice(1)
                      : "---"}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Currency</h4>
                  <div>
                    {botDetails?.order_currency_type === "base"
                      ? "Base"
                      : botDetails?.order_currency_type === "quote"
                        ? "Quote"
                        : botDetails?.order_currency_type || "---"}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Leverage</h4>
                  <div>
                    {botDetails?.leverage_type
                      ? botDetails.leverage_type.charAt(0).toUpperCase() +
                        botDetails.leverage_type.slice(1).replace("_", " ")
                      : "---"}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Current Price</h4>
                  <div>{botDetails?.current_price || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className="display-2">
                  <h4>Profit (USD)</h4>
                  <div>{botDetails?.current_profit_usd || "---"}</div>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className="flexend mb-20">
                  <div className="bot_comman_btn">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={botEnabled}
                          onChange={(e) =>
                            handleToggleBotStatus(e.target.checked)
                          }
                          color="primary"
                          disabled={toggleLoading}
                        />
                      }
                      label={botEnabled ? "Enabled" : "Disabled"}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-20">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="custom_table box_bdr mt-20">
            <div className="h_flx">
              <h3>Order List</h3>
            </div>

            <TableContainer sx={{ marginBottom: "10px" }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Order Time</TableCell>
                    <TableCell>Pair</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Side</TableCell>
                    <TableCell>Price (Rate)</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Remaining</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Avg Price</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tradeLoading ? (
                    <TableRow>
                      <TableCell colSpan={11}>
                        <div className="inline-loader">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : activePaginated?.length > 0 ? (
                    activePaginated.map((row, i) => (
                      <TableRow key={i} className="tr_row">
                        <TableCell>{formatDate(row.created_at)}</TableCell>
                        <TableCell>{botDetails?.pair || "---"}</TableCell>
                        <TableCell>{row.orderCategory || "---"}</TableCell>
                        <TableCell
                          style={{
                            color:
                              row.order_type === "BUY" ? "#00C853" : "#FF5252",
                          }}
                        >
                          {row.order_type || "---"}
                        </TableCell>
                        <TableCell>{row.rate || "---"}</TableCell>
                        <TableCell>{row.quantity || "---"}</TableCell>
                        <TableCell>{row.quantity_remaining || "---"}</TableCell>
                        <TableCell>{row.total || "---"}</TableCell>
                        <TableCell>{row.average_price || "---"}</TableCell>
                        <TableCell>{row.order_id || "---"}</TableCell>
                        <TableCell>{row.status_string || "---"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        No Orders Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={gridOrders.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Gridorderlist;
